import { render, staticRenderFns } from "./TimesheetSubmissionDeadline.vue?vue&type=template&id=5c5a011b&scoped=true&"
import script from "./TimesheetSubmissionDeadline.vue?vue&type=script&lang=js&"
export * from "./TimesheetSubmissionDeadline.vue?vue&type=script&lang=js&"
import style0 from "./TimesheetSubmissionDeadline.vue?vue&type=style&index=0&id=5c5a011b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a011b",
  null
  
)

export default component.exports